var calEvents = {
    "sharedView" : null,
    "sharedIds" : [],
    "cssSelector" : "",
    "date_range" : {"start" : "", "end" : ""},
    "calendars" : [],
    "language" : "",
};
export {calEvents as calEvents};